import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPurchaseOrderList } from '../../Interfaces/IPurchaseOrder'

export interface IPurchaseOrderListState {
    purchaseOrders: IPurchaseOrderList | undefined;
}

export const defaultState: IPurchaseOrderListState = {
    purchaseOrders: {
        list: [],
        numberOfPageItems: 0,
        pageNumber: 0,
        totalCount: 0
    }
}

export const purchaseOrderReducer = createSlice({
    name: 'purchaseOrderList',
    initialState: defaultState,
    reducers: {
        setPurchaseOrderList: (state, action: PayloadAction<IPurchaseOrderList | undefined>) => {
            state.purchaseOrders = action.payload
        },
    },
});

//export const purchaseOrderActions =purchaseOrderReducer.actions;

export default purchaseOrderReducer.reducer;